<script>
  import Table from "./Table.svelte";
  import InputTable from "./Input/InputTable.svelte";
  import ButtonTable from "./Button/ButtonTable.svelte";
  import ResultComponent from "./ResultComponent.svelte";
  import { InputStore } from "../store";
  import { ResultStore } from "../store";


  export let Cipher;

  let cipher = Cipher;


  let Input = {}
  let Result = []

  InputStore.subscribe((inputs) => {
    Input = inputs
    
  })
  ResultStore.subscribe((results) => {
    Result = results
  })

  InputStore.update((currentInputs) => currentInputs = {})
  console.log(Cipher);
  cipher.input.forEach(input => {
      InputStore.update((currentInputs) => currentInputs = {...currentInputs, [input.id]: input.value})
      console.log('idk', Input);
  });

  // $: console.log(Input);

  const handleClick = (e) => {
    let action = e.detail
    ResultStore.set(cipher.crypt(Input, action))
  }
</script>

<main>
  <h1>{cipher.name}</h1>
  <Table> 
    <InputTable Inputs={cipher.input}/>
    <ButtonTable buttonsValues = {cipher.buttons} on:handleClick={handleClick}/>
  </Table>

  <h2 class="resultsTitle">Výsledky</h2>
  <Table class="results">
    {#each Result as result}
      <ResultComponent resultText={result} />
    {/each}
  </Table>
</main>

<style>
  main {
		text-align: center;
		margin: 0 auto;

    width: 40vw;

    font-size: 1.5rem;
	}

  h1 {
    text-transform: uppercase;
    font-size: 1.5em;
  }

  h2.resultsTitle {
    text-align: left;
  }

</style>